// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════
   AttendanceHistoryPage
   ══════════════════════════════════════════════════════════ */

.ahp-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f7fa;
}

/* ── Header ──────────────────────────────────────────── */
.ahp-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1px solid #eaecf0;
}

.ahp-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #f0f2f5;
  color: #374151;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.ahp-back-btn:hover { background: #e5e7eb; }

.ahp-header-text h1 {
  font-size: 17px;
  font-weight: 700;
  color: #1a2236;
  margin: 0;
}
.ahp-header-text p {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
}

/* ── Body ────────────────────────────────────────────── */
.ahp-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
}

/* ── Toolbar ─────────────────────────────────────────── */
.ahp-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.ahp-toolbar-left {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex: 1;
  flex-wrap: wrap;
}

.ahp-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.ahp-input {
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  color: #1a2236;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
  min-width: 140px;
}
.ahp-input:focus { border-color: #1e5fbc; }

.ahp-search-field { flex: 1; min-width: 200px; }

.ahp-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.ahp-search-wrap svg {
  position: absolute;
  left: 10px;
  color: #9ca3af;
  pointer-events: none;
}
.ahp-search-wrap .ahp-input {
  padding-left: 34px;
  width: 100%;
}

.ahp-search-btn {
  height: 38px;
  padding: 0 24px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s;
}
.ahp-search-btn:hover:not(:disabled) { opacity: 0.9; }
.ahp-search-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Employee not found ──────────────────────────────── */
.ahp-emp-not-found {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #78350f;
}
.ahp-emp-not-found-icon {
  flex-shrink: 0;
  color: #d97706;
  margin-top: 2px;
}
.ahp-emp-not-found-body strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 6px;
}
.ahp-emp-not-found-body p {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #92400e;
}
.dark .ahp-emp-not-found {
  background: #2d1a00;
  border-color: #78350f;
  color: #fbbf24;
}
.dark .ahp-emp-not-found-icon { color: #fbbf24; }
.dark .ahp-emp-not-found-body p { color: #fcd34d; }

/* ── Error ───────────────────────────────────────────── */
.ahp-error {
  padding: 14px 18px;
  border-radius: 10px;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  color: #be123c;
  font-size: 14px;
}

/* ── Skeleton ────────────────────────────────────────── */
.ahp-skeleton {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ahp-skeleton-row {
  display: flex;
  gap: 12px;
}

.ahp-skeleton-cell {
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f2f5 25%, #e5e7eb 50%, #f0f2f5 75%);
  background-size: 200% 100%;
  animation: ahp-shimmer 1.2s infinite;
  flex: 1;
}
.ahp-skeleton-cell.wide   { flex: 2; }
.ahp-skeleton-cell.narrow { flex: 0.6; }

/* Toolbar placeholder row */
.ahp-skeleton-toolbar {
  padding-bottom: 8px;
  border-bottom: 1px solid #eaecf0;
  margin-bottom: 8px;
}

/* Column-header row — shorter, more muted */
.ahp-skeleton-th {
  padding: 2px 0 10px;
}
.ahp-skeleton-th .ahp-skeleton-cell {
  height: 10px !important;
  opacity: 0.5;
}

/* Employee cell double-line (name + id) */
.ahp-skeleton-cell--double {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: none !important;
  animation: none !important;
}
.ahp-skeleton-cell--double::before,
.ahp-skeleton-cell--double::after {
  content: "";
  display: block;
  height: 13px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f2f5 25%, #e5e7eb 50%, #f0f2f5 75%);
  background-size: 200% 100%;
  animation: ahp-shimmer 1.2s infinite;
}
.ahp-skeleton-cell--double::after {
  width: 55%;
  height: 10px;
  opacity: 0.6;
}

/* Badge-shaped status skeleton */
.ahp-skeleton-badge {
  height: 20px !important;
  border-radius: 20px !important;
  max-width: 80px;
}

@keyframes ahp-shimmer { to { background-position: -200% 0; } }

/* ── Empty state ─────────────────────────────────────── */
.ahp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 60px 24px;
  color: #94a3b8;
  text-align: center;
  font-size: 14px;
}

/* ── Table ───────────────────────────────────────────── */
.ahp-table-wrap {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  overflow-x: auto;
}

.ahp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.ahp-table thead {
  background: #f8fafc;
  border-bottom: 1px solid #eaecf0;
}

.ahp-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 700;
  color: #374151;
  white-space: nowrap;
}

.ahp-table td {
  padding: 12px 16px;
  color: #1a2236;
  border-bottom: 1px solid #f3f4f6;
}

.ahp-table tbody tr:last-child td { border-bottom: none; }

.ahp-table tbody tr:hover { background: #f8fafc; }

/* ── Employee cell ───────────────────────────────────── */
.ahp-emp-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ahp-emp-name {
  font-weight: 600;
  color: #1a2236;
}
.ahp-emp-id {
  font-size: 11px;
  color: #9ca3af;
}

/* ── Result count ────────────────────────────────────── */
.ahp-result-count {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
}

/* ── Error with retry ────────────────────────────────── */
.ahp-retry-btn {
  margin-left: 12px;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid #fecdd3;
  background: #fff;
  color: #be123c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.ahp-retry-btn:hover { background: #fff1f2; }

/* ── Badge ───────────────────────────────────────────── */
.ahp-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
}

/* Status variants */
.ahp-badge--in       { background: #dcfce7; color: #15803d; }
.ahp-badge--out      { background: #dbeafe; color: #1e40af; }
.ahp-badge--overtime { background: #fef3c7; color: #92400e; }
.ahp-badge--halfday  { background: #ede9fe; color: #6d28d9; }
.ahp-badge--absent   { background: #fee2e2; color: #b91c1c; }
.ahp-badge--off      { background: #f3f4f6; color: #6b7280; }
.ahp-badge--leave    { background: #e0f2fe; color: #0369a1; }
.ahp-badge--late     { background: #ffedd5; color: #c2410c; }
.ahp-badge--unknown  { background: #f3f4f6; color: #6b7280; }

/* ── Pagination ──────────────────────────────────────── */
.ahp-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.ahp-page-btn {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.ahp-page-btn:hover:not(:disabled) { background: #f0f2f5; }
.ahp-page-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.ahp-page-info {
  font-size: 13px;
  color: #6b7280;
}

/* ── Clickable rows ──────────────────────────────────── */
.ahp-row-clickable {
  cursor: pointer;
  transition: background 0.12s;
}
.ahp-row-clickable:hover  { background: #f0f4ff; }
.ahp-row-clickable:focus  { outline: 2px solid #1e5fbc; outline-offset: -2px; }
.ahp-row-chevron {
  color: #d1d5db;
  text-align: right;
  padding-right: 12px;
}
.ahp-row-clickable:hover .ahp-row-chevron { color: #1e5fbc; }

/* ══════════════════════════════════════════════════════════
   Attendance Detail Panel  — premium redesign
   ══════════════════════════════════════════════════════════ */

/* Backdrop */
.adp-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 14, 30, 0.55);
  z-index: 200;
  backdrop-filter: blur(2px);
  animation: adp-fade-in 0.2s ease;
}
@keyframes adp-fade-in { from { opacity: 0; } to { opacity: 1; } }

/* Slide-in panel */
.adp-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(520px, 100vw);
  background: #f0f4f8;
  z-index: 201;
  /* Grid is the most reliable layout for header-fixed / body-scrolls pattern:
     first row = header (auto height), second row = body (fills remaining space exactly) */
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  box-shadow: -12px 0 48px rgba(0,0,0,0.22);
  animation: adp-slide-in 0.24s cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes adp-slide-in {
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
}

/* ── Gradient header ──────────────────────────────────── */
.adp-panel-header {
  background: linear-gradient(135deg, #0d1b3e 0%, #1e4ba0 100%);
  flex-shrink: 0;
  padding: 20px 20px 0;
}

.adp-header-top {
  display: flex;
  align-items: center;
  gap: 14px;
}

/* Initials avatar */
.adp-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255,255,255,0.18);
  border: 2px solid rgba(255,255,255,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  flex-shrink: 0;
  letter-spacing: -1px;
}

.adp-header-info { flex: 1; min-width: 0; }
.adp-panel-name {
  font-size: 17px;
  font-weight: 800;
  color: #fff;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.adp-panel-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
  flex-wrap: wrap;
}
.adp-panel-empid {
  font-size: 11px;
  color: rgba(255,255,255,0.55);
  font-weight: 600;
  font-family: monospace;
}
.adp-panel-date {
  font-size: 11px;
  color: rgba(255,255,255,0.65);
}

/* Close button — white circle */
.adp-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.15);
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.adp-close-btn:hover { background: rgba(255,255,255,0.28); }

/* Status + verification chip strip */
.adp-header-chips {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 0 16px;
  flex-wrap: wrap;
}
.adp-vmode-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 11px;
  background: rgba(255,255,255,0.15);
  color: rgba(255,255,255,0.85);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border: 1px solid rgba(255,255,255,0.25);
}

/* Panel scrollable body
   IMPORTANT: must be display:block (not flex).
   flex+overflow-y causes "scrollbar moves but content stays" in Chrome. */
.adp-panel-body {
  /* Grid places this in the 1fr row — it fills the remaining panel height exactly */
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 18px 16px 24px;
}

/* Space between sections via sibling selector (replaces flex gap) */
.adp-panel-body > * + * {
  margin-top: 12px;
}

/* Loading */
.adp-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 60px 24px;
  color: #6b7280;
  font-size: 13px;
}
.adp-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top-color: #1e5fbc;
  border-radius: 50%;
  animation: adp-spin 0.75s linear infinite;
}
@keyframes adp-spin { to { transform: rotate(360deg); } }

/* Error */
.adp-detail-error {
  padding: 12px 16px;
  border-radius: 10px;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  color: #be123c;
  font-size: 13px;
  font-weight: 500;
}

/* ── Stats cards grid ─────────────────────────────────── */
.adp-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 8px;
}

.adp-stat-card {
  background: #fff;
  border-radius: 14px;
  padding: 14px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border-top: 3px solid #e2e8f0;
}
.adp-stat-card--in   { border-top-color: #16a34a; }
.adp-stat-card--out  { border-top-color: #2563eb; }
.adp-stat-card--work { border-top-color: #7c3aed; }
.adp-stat-card--dist { border-top-color: #0891b2; }

.adp-stat-card-ico {
  font-size: 16px;
  line-height: 1;
}
.adp-stat-card-val {
  font-size: 18px;
  font-weight: 800;
  color: #1a2236;
  line-height: 1;
}
.adp-stat-card--in  .adp-stat-card-val { color: #16a34a; }
.adp-stat-card--out .adp-stat-card-val { color: #2563eb; }
.adp-stat-card-lbl {
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  text-align: center;
}

/* ── Alert banner (late / early) ──────────────────────── */
.adp-alert-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
}
.adp-alert-banner--late  { background: #fff7ed; color: #c2410c; border: 1.5px solid #fed7aa; }
.adp-alert-banner--early { background: #eff6ff; color: #1d4ed8; border: 1.5px solid #bfdbfe; }
.adp-alert-icon { font-size: 16px; flex-shrink: 0; }

/* ── Face recognition card ────────────────────────────── */
.adp-face-card {
  background: linear-gradient(135deg, #f0f7ff, #e8f0fe);
  border: 1.5px solid #bfdbfe;
  border-radius: 14px;
  padding: 14px 16px;
}
.adp-face-card-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #1e5fbc;
  margin-bottom: 12px;
}
.adp-face-row {
  display: flex;
  align-items: center;
  gap: 20px;
}
.adp-match-ring {
  position: relative;
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}
.adp-match-pct {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
}
.adp-face-meta { flex: 1; }
.adp-face-pct {
  font-size: 26px;
  font-weight: 800;
  color: var(--ring-color, #1a2236);
  line-height: 1.1;
}
.adp-face-hint {
  font-size: 12px;
  color: #374151;
  margin-top: 5px;
  font-weight: 500;
}

/* ── Sections ─────────────────────────────────────────── */
.adp-section {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
  border: 1px solid #eaecf0;
}
.adp-section-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #94a3b8;
  padding: 11px 16px 9px;
  border-bottom: 1px solid #f3f4f6;
  margin: 0;
  background: #fafbfc;
}
.adp-section-body { padding: 2px 0; }

/* Info rows */
.adp-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 16px;
  border-bottom: 1px solid #f8fafc;
}
.adp-row:last-child { border-bottom: none; }
.adp-row-label {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
  flex-shrink: 0;
  padding-top: 1px;
}
.adp-row-value {
  font-size: 13px;
  color: #1a2236;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}
.adp-row-value--hl { color: #1e5fbc; }

/* ── Remarks card ─────────────────────────────────────── */
.adp-remarks-card {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #eaecf0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.adp-remarks-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #94a3b8;
  padding: 11px 16px 9px;
  border-bottom: 1px solid #f3f4f6;
  background: #fafbfc;
}
.adp-remarks {
  font-size: 12px;
  color: #374151;
  line-height: 1.7;
  padding: 12px 16px;
  margin: 0;
  white-space: pre-line;
  word-break: break-word;
}

/* ── Activity timeline ────────────────────────────────── */
.adp-timeline {
  padding: 12px 14px 6px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.adp-timeline-event {
  display: flex;
  gap: 14px;
  position: relative;
  padding-bottom: 18px;
}
.adp-timeline-event--last { padding-bottom: 4px; }

/* vertical connector */
.adp-timeline-event::before {
  content: "";
  position: absolute;
  left: 9px;
  top: 20px;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #cbd5e1, transparent);
}
.adp-timeline-event--last::before { display: none; }

/* dot */
.adp-tl-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-size: 10px;
  font-weight: 900;
  color: #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.18);
}
.adp-tl-dot--in  { background: linear-gradient(135deg, #16a34a, #4ade80); }
.adp-tl-dot--out { background: linear-gradient(135deg, #1d4ed8, #60a5fa); }

/* event card */
.adp-tl-body {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eaecf0;
  padding: 10px 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.adp-tl-type {
  font-size: 13px;
  font-weight: 700;
  color: #1a2236;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.adp-tl-mode {
  font-size: 9px;
  font-weight: 700;
  background: #eff6ff;
  color: #1e5fbc;
  padding: 2px 7px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border: 1px solid #bfdbfe;
}
.adp-tl-time     { font-size: 12px; color: #374151; margin-top: 4px; font-weight: 600; }
.adp-tl-location { font-size: 12px; color: #64748b; margin-top: 3px; font-weight: 500; }
.adp-tl-address  { font-size: 11px; color: #94a3b8; margin-top: 2px; line-height: 1.4; }
.adp-tl-latlng   { font-size: 10px; color: #cbd5e1; margin-top: 3px; font-family: monospace; }
.adp-tl-match    { font-size: 11px; color: #6b7280; margin-top: 4px; }
.adp-tl-match strong { color: #1a2236; }
.adp-tl-worked   { font-size: 11px; color: #16a34a; margin-top: 3px; font-weight: 700; }
.adp-tl-device   { font-size: 11px; color: #94a3b8; margin-top: 2px; }

/* ══════════════════════════════════════════════════════════
   Dark mode
   ══════════════════════════════════════════════════════════ */
.dark .ahp-root { background: #121827; }
.dark .ahp-header { background: #1a2236; border-color: #2e3d52; }
.dark .ahp-header-text h1 { color: #e2e8f0; }
.dark .ahp-header-text p { color: #94a3b8; }
.dark .ahp-back-btn { background: #263348; color: #cbd5e1; }
.dark .ahp-back-btn:hover { background: #2e3d52; }
.dark .ahp-toolbar { background: #1a2236; box-shadow: 0 2px 12px rgba(0,0,0,0.25); }
.dark .ahp-field { color: #94a3b8; }
.dark .ahp-input { background: #0f1724; border-color: #2e3d52; color: #e2e8f0; }
.dark .ahp-input:focus { border-color: #7eb3ff; }
.dark .ahp-error { background: #1f0a10; border-color: #9f1239; color: #fb7185; display: flex; align-items: center; }
.dark .ahp-retry-btn { background: #1f0a10; border-color: #9f1239; color: #fb7185; }
.dark .ahp-retry-btn:hover { background: #2d0d18; }
.dark .ahp-result-count { color: #94a3b8; }
.dark .ahp-emp-name { color: #e2e8f0; }
.dark .ahp-emp-id { color: #4b5e76; }
.dark .ahp-skeleton { background: #1a2236; }
.dark .ahp-skeleton-cell {
  background: linear-gradient(90deg, #1e2a3e 25%, #263348 50%, #1e2a3e 75%);
  background-size: 200% 100%;
}
.dark .ahp-empty { color: #4b5e76; }
.dark .ahp-table-wrap { background: #1a2236; box-shadow: 0 2px 12px rgba(0,0,0,0.25); }
.dark .ahp-table thead { background: #0f1724; border-color: #2e3d52; }
.dark .ahp-table th { color: #94a3b8; }
.dark .ahp-table td { color: #e2e8f0; border-color: #1e2a3e; }
.dark .ahp-table tbody tr:hover { background: #0f1724; }
.dark .ahp-badge--in       { background: #052e16; color: #4ade80; }
.dark .ahp-badge--out      { background: #1e3a5f; color: #93c5fd; }
.dark .ahp-badge--overtime { background: #2d1f04; color: #fbbf24; }
.dark .ahp-badge--halfday  { background: #2e1065; color: #c4b5fd; }
.dark .ahp-badge--absent   { background: #450a0a; color: #fca5a5; }
.dark .ahp-badge--off      { background: #1e2a3e; color: #64748b; }
.dark .ahp-badge--leave    { background: #0c2a3e; color: #7dd3fc; }
.dark .ahp-badge--late     { background: #3b1505; color: #fb923c; }
.dark .ahp-badge--unknown  { background: #1e2a3e; color: #64748b; }
.dark .ahp-page-btn { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }
.dark .ahp-page-btn:hover:not(:disabled) { background: #263348; }
.dark .ahp-page-info { color: #94a3b8; }

/* ── Dark: clickable rows ────────────────────────────── */
.dark .ahp-row-clickable:hover  { background: #0f1724; }
.dark .ahp-row-chevron          { color: #2e3d52; }
.dark .ahp-row-clickable:hover .ahp-row-chevron { color: #7eb3ff; }

/* ── Dark: detail panel ──────────────────────────────── */
.dark .adp-backdrop  { background: rgba(0,0,0,0.72); }
.dark .adp-panel     { background: #0f1724; }

/* header gradient stays in dark mode — already dark enough */
.dark .adp-panel-header { background: linear-gradient(135deg, #060d1e 0%, #0f2d6a 100%); }
.dark .adp-close-btn    { background: rgba(255,255,255,0.12); color: #e2e8f0; }
.dark .adp-close-btn:hover { background: rgba(255,255,255,0.22); }

/* stats */
.dark .adp-stats-grid .adp-stat-card { background: #1a2236; border-color: #2e3d52; box-shadow: 0 2px 8px rgba(0,0,0,0.3); }
.dark .adp-stat-card-val              { color: #e2e8f0; }
.dark .adp-stat-card--in  .adp-stat-card-val { color: #4ade80; }
.dark .adp-stat-card--out .adp-stat-card-val { color: #93c5fd; }
.dark .adp-stat-card-lbl              { color: #4b5e76; }

/* alert banners */
.dark .adp-alert-banner--late  { background: #1c0a00; color: #fb923c; border-color: #7c2d12; }
.dark .adp-alert-banner--early { background: #0c1a3e; color: #93c5fd; border-color: #1e3a6e; }

/* face card */
.dark .adp-face-card       { background: linear-gradient(135deg, #0f1f3d, #1e2a52); border-color: #1e3a6e; }
.dark .adp-face-card-title { color: #7eb3ff; }
.dark .adp-face-pct        { /* uses CSS var --ring-color */ }
.dark .adp-face-hint       { color: #94a3b8; }

/* sections */
.dark .adp-section       { background: #1a2236; border-color: #2e3d52; box-shadow: 0 2px 8px rgba(0,0,0,0.3); }
.dark .adp-section-title { color: #4b5e76; border-color: #2e3d52; background: #131e30; }
.dark .adp-section-body  { }
.dark .adp-row           { border-color: #1e2a3e; }
.dark .adp-row-label     { color: #4b5e76; }
.dark .adp-row-value     { color: #e2e8f0; }
.dark .adp-row-value--hl { color: #7eb3ff; }

/* remarks */
.dark .adp-remarks-card  { background: #1a2236; border-color: #2e3d52; }
.dark .adp-remarks-title { color: #4b5e76; border-color: #2e3d52; background: #131e30; }
.dark .adp-remarks       { color: #94a3b8; }

/* timeline */
.dark .adp-timeline-event::before { background: linear-gradient(to bottom, #2e3d52, transparent); }
.dark .adp-tl-dot--in  { background: linear-gradient(135deg, #16a34a, #4ade80); }
.dark .adp-tl-dot--out { background: linear-gradient(135deg, #1d4ed8, #60a5fa); }
.dark .adp-tl-body     { background: #1a2236; border-color: #2e3d52; }
.dark .adp-tl-type     { color: #e2e8f0; }
.dark .adp-tl-mode     { background: #0f1f3d; color: #7eb3ff; border-color: #1e3a6e; }
.dark .adp-tl-time     { color: #cbd5e1; }
.dark .adp-tl-location { color: #94a3b8; }
.dark .adp-tl-address  { color: #64748b; }
.dark .adp-tl-latlng   { color: #374151; }
.dark .adp-tl-match    { color: #64748b; }
.dark .adp-tl-match strong { color: #cbd5e1; }
.dark .adp-tl-worked   { color: #4ade80; }
.dark .adp-tl-device   { color: #4b5e76; }

/* loading / error */
.dark .adp-loading      { color: #4b5e76; }
.dark .adp-spinner      { border-color: #2e3d52; border-top-color: #7eb3ff; }
.dark .adp-detail-error { background: #1f0a10; border-color: #9f1239; color: #fb7185; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/AttendanceHistoryPage.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA,mBAAmB,qBAAqB,EAAE;;AAE1C,oBAAoB,OAAO,EAAE,gBAAgB,EAAE;;AAE/C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,uCAAuC,YAAY,EAAE;AACrD,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,gCAAgC,cAAc,EAAE;AAChD,kCAAkC,cAAc,EAAE;;AAElD,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oCAAoC;EACpC,OAAO;AACT;AACA,4BAA4B,OAAO,EAAE;AACrC,4BAA4B,SAAS,EAAE;;AAEvC,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;;EAEE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,yBAAyB,KAAK,4BAA4B,EAAE,EAAE;;AAE9D,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD,4BAA4B,mBAAmB,EAAE;;AAEjD,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA,4BAA4B,mBAAmB,EAAE;AACjD,4BAA4B,0BAA0B,EAAE,oBAAoB,EAAE;AAC9E;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA,4CAA4C,cAAc,EAAE;;AAE5D;;+DAE+D;;AAE/D,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;AAClC;AACA,yBAAyB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEjE,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ;0FACwF;EACxF,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;EACzC,2DAA2D;AAC7D;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA,4DAA4D;AAC5D;EACE,6DAA6D;EAC7D,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA,mBAAmB,OAAO,EAAE,YAAY,EAAE;AAC1C;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA,uBAAuB,kCAAkC,EAAE;;AAE3D,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;0EAE0E;AAC1E;EACE,kFAAkF;EAClF,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;;AAExD,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,6BAA6B;AAC/B;AACA,uBAAuB,yBAAyB,EAAE;AAClD,uBAAuB,yBAAyB,EAAE;AAClD,uBAAuB,yBAAyB,EAAE;AAClD,uBAAuB,yBAAyB,EAAE;;AAElD;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AAC7F,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AAC7F,kBAAkB,eAAe,EAAE,cAAc,EAAE;;AAEnD,4DAA4D;AAC5D;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA,iBAAiB,OAAO,EAAE;AAC1B;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;AACA,oBAAoB,cAAc,EAAE;;AAEpC,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA,qBAAqB,cAAc,EAAE;;AAErC,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,SAAS;EACT,UAAU;EACV,4DAA4D;AAC9D;AACA,oCAAoC,aAAa,EAAE;;AAEnD,QAAQ;AACR;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;AACA,mBAAmB,qDAAqD,EAAE;AAC1E,mBAAmB,qDAAqD,EAAE;;AAE1E,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvF,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvF,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvF,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC7F,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACrE,uBAAuB,cAAc,EAAE;AACvC,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvF,mBAAmB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAErE;;+DAE+D;AAC/D,kBAAkB,mBAAmB,EAAE;AACvC,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE;AAChE,4BAA4B,cAAc,EAAE;AAC5C,2BAA2B,cAAc,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,4BAA4B,mBAAmB,EAAE;AACjD,qBAAqB,mBAAmB,EAAE,uCAAuC,EAAE;AACnF,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC/E,yBAAyB,qBAAqB,EAAE;AAChD,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACnH,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnF,6BAA6B,mBAAmB,EAAE;AAClD,0BAA0B,cAAc,EAAE;AAC1C,sBAAsB,cAAc,EAAE;AACtC,oBAAoB,cAAc,EAAE;AACpC,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;AACA,mBAAmB,cAAc,EAAE;AACnC,wBAAwB,mBAAmB,EAAE,uCAAuC,EAAE;AACtF,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;AACrE,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;AAC7D,kCAAkC,mBAAmB,EAAE;AACvD,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAClF,2CAA2C,mBAAmB,EAAE;AAChE,uBAAuB,cAAc,EAAE;;AAEvC,2DAA2D;AAC3D,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,cAAc,EAAE;AAClD,kDAAkD,cAAc,EAAE;;AAElE,2DAA2D;AAC3D,uBAAuB,4BAA4B,EAAE;AACrD,uBAAuB,mBAAmB,EAAE;;AAE5C,6DAA6D;AAC7D,0BAA0B,6DAA6D,EAAE;AACzF,0BAA0B,kCAAkC,EAAE,cAAc,EAAE;AAC9E,6BAA6B,kCAAkC,EAAE;;AAEjE,UAAU;AACV,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE,qCAAqC,EAAE;AAC1H,wCAAwC,cAAc,EAAE;AACxD,+CAA+C,cAAc,EAAE;AAC/D,+CAA+C,cAAc,EAAE;AAC/D,wCAAwC,cAAc,EAAE;;AAExD,kBAAkB;AAClB,iCAAiC,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC7F,iCAAiC,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE7F,cAAc;AACd,6BAA6B,qDAAqD,EAAE,qBAAqB,EAAE;AAC3G,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,8BAA8B,EAAE;AAC7D,6BAA6B,cAAc,EAAE;;AAE7C,aAAa;AACb,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE,qCAAqC,EAAE;AAC9G,2BAA2B,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACvF,2BAA2B;AAC3B,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;;AAE3C,YAAY;AACZ,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE;AACvE,2BAA2B,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACvF,2BAA2B,cAAc,EAAE;;AAE3C,aAAa;AACb,oCAAoC,4DAA4D,EAAE;AAClG,yBAAyB,qDAAqD,EAAE;AAChF,yBAAyB,qDAAqD,EAAE;AAChF,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;AACrE,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACrF,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,6BAA6B,cAAc,EAAE;AAC7C,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC,oBAAoB;AACpB,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,qBAAqB,EAAE,yBAAyB,EAAE;AAC5E,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════════════════════════\n   AttendanceHistoryPage\n   ══════════════════════════════════════════════════════════ */\n\n.ahp-root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #f5f7fa;\n}\n\n/* ── Header ──────────────────────────────────────────── */\n.ahp-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  background: #fff;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.ahp-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: none;\n  background: #f0f2f5;\n  color: #374151;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n.ahp-back-btn:hover { background: #e5e7eb; }\n\n.ahp-header-text h1 {\n  font-size: 17px;\n  font-weight: 700;\n  color: #1a2236;\n  margin: 0;\n}\n.ahp-header-text p {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n/* ── Body ────────────────────────────────────────────── */\n.ahp-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px;\n}\n\n/* ── Toolbar ─────────────────────────────────────────── */\n.ahp-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.05);\n}\n\n.ahp-toolbar-left {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  flex: 1;\n  flex-wrap: wrap;\n}\n\n.ahp-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.ahp-input {\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #1a2236;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.15s;\n  min-width: 140px;\n}\n.ahp-input:focus { border-color: #1e5fbc; }\n\n.ahp-search-field { flex: 1; min-width: 200px; }\n\n.ahp-search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.ahp-search-wrap svg {\n  position: absolute;\n  left: 10px;\n  color: #9ca3af;\n  pointer-events: none;\n}\n.ahp-search-wrap .ahp-input {\n  padding-left: 34px;\n  width: 100%;\n}\n\n.ahp-search-btn {\n  height: 38px;\n  padding: 0 24px;\n  border-radius: 8px;\n  border: none;\n  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 0.15s;\n}\n.ahp-search-btn:hover:not(:disabled) { opacity: 0.9; }\n.ahp-search-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── Employee not found ──────────────────────────────── */\n.ahp-emp-not-found {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px 24px;\n  border-radius: 12px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  color: #78350f;\n}\n.ahp-emp-not-found-icon {\n  flex-shrink: 0;\n  color: #d97706;\n  margin-top: 2px;\n}\n.ahp-emp-not-found-body strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.ahp-emp-not-found-body p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #92400e;\n}\n.dark .ahp-emp-not-found {\n  background: #2d1a00;\n  border-color: #78350f;\n  color: #fbbf24;\n}\n.dark .ahp-emp-not-found-icon { color: #fbbf24; }\n.dark .ahp-emp-not-found-body p { color: #fcd34d; }\n\n/* ── Error ───────────────────────────────────────────── */\n.ahp-error {\n  padding: 14px 18px;\n  border-radius: 10px;\n  background: #fff1f2;\n  border: 1px solid #fecdd3;\n  color: #be123c;\n  font-size: 14px;\n}\n\n/* ── Skeleton ────────────────────────────────────────── */\n.ahp-skeleton {\n  background: #fff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ahp-skeleton-row {\n  display: flex;\n  gap: 12px;\n}\n\n.ahp-skeleton-cell {\n  height: 22px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #f0f2f5 25%, #e5e7eb 50%, #f0f2f5 75%);\n  background-size: 200% 100%;\n  animation: ahp-shimmer 1.2s infinite;\n  flex: 1;\n}\n.ahp-skeleton-cell.wide   { flex: 2; }\n.ahp-skeleton-cell.narrow { flex: 0.6; }\n\n/* Toolbar placeholder row */\n.ahp-skeleton-toolbar {\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eaecf0;\n  margin-bottom: 8px;\n}\n\n/* Column-header row — shorter, more muted */\n.ahp-skeleton-th {\n  padding: 2px 0 10px;\n}\n.ahp-skeleton-th .ahp-skeleton-cell {\n  height: 10px !important;\n  opacity: 0.5;\n}\n\n/* Employee cell double-line (name + id) */\n.ahp-skeleton-cell--double {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  background: none !important;\n  animation: none !important;\n}\n.ahp-skeleton-cell--double::before,\n.ahp-skeleton-cell--double::after {\n  content: \"\";\n  display: block;\n  height: 13px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #f0f2f5 25%, #e5e7eb 50%, #f0f2f5 75%);\n  background-size: 200% 100%;\n  animation: ahp-shimmer 1.2s infinite;\n}\n.ahp-skeleton-cell--double::after {\n  width: 55%;\n  height: 10px;\n  opacity: 0.6;\n}\n\n/* Badge-shaped status skeleton */\n.ahp-skeleton-badge {\n  height: 20px !important;\n  border-radius: 20px !important;\n  max-width: 80px;\n}\n\n@keyframes ahp-shimmer { to { background-position: -200% 0; } }\n\n/* ── Empty state ─────────────────────────────────────── */\n.ahp-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 60px 24px;\n  color: #94a3b8;\n  text-align: center;\n  font-size: 14px;\n}\n\n/* ── Table ───────────────────────────────────────────── */\n.ahp-table-wrap {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.05);\n  overflow-x: auto;\n}\n\n.ahp-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.ahp-table thead {\n  background: #f8fafc;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.ahp-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 700;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.ahp-table td {\n  padding: 12px 16px;\n  color: #1a2236;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.ahp-table tbody tr:last-child td { border-bottom: none; }\n\n.ahp-table tbody tr:hover { background: #f8fafc; }\n\n/* ── Employee cell ───────────────────────────────────── */\n.ahp-emp-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.ahp-emp-name {\n  font-weight: 600;\n  color: #1a2236;\n}\n.ahp-emp-id {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* ── Result count ────────────────────────────────────── */\n.ahp-result-count {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* ── Error with retry ────────────────────────────────── */\n.ahp-retry-btn {\n  margin-left: 12px;\n  padding: 4px 12px;\n  border-radius: 6px;\n  border: 1px solid #fecdd3;\n  background: #fff;\n  color: #be123c;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.ahp-retry-btn:hover { background: #fff1f2; }\n\n/* ── Badge ───────────────────────────────────────────── */\n.ahp-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n/* Status variants */\n.ahp-badge--in       { background: #dcfce7; color: #15803d; }\n.ahp-badge--out      { background: #dbeafe; color: #1e40af; }\n.ahp-badge--overtime { background: #fef3c7; color: #92400e; }\n.ahp-badge--halfday  { background: #ede9fe; color: #6d28d9; }\n.ahp-badge--absent   { background: #fee2e2; color: #b91c1c; }\n.ahp-badge--off      { background: #f3f4f6; color: #6b7280; }\n.ahp-badge--leave    { background: #e0f2fe; color: #0369a1; }\n.ahp-badge--late     { background: #ffedd5; color: #c2410c; }\n.ahp-badge--unknown  { background: #f3f4f6; color: #6b7280; }\n\n/* ── Pagination ──────────────────────────────────────── */\n.ahp-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.ahp-page-btn {\n  padding: 8px 20px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.ahp-page-btn:hover:not(:disabled) { background: #f0f2f5; }\n.ahp-page-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.ahp-page-info {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* ── Clickable rows ──────────────────────────────────── */\n.ahp-row-clickable {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.ahp-row-clickable:hover  { background: #f0f4ff; }\n.ahp-row-clickable:focus  { outline: 2px solid #1e5fbc; outline-offset: -2px; }\n.ahp-row-chevron {\n  color: #d1d5db;\n  text-align: right;\n  padding-right: 12px;\n}\n.ahp-row-clickable:hover .ahp-row-chevron { color: #1e5fbc; }\n\n/* ══════════════════════════════════════════════════════════\n   Attendance Detail Panel  — premium redesign\n   ══════════════════════════════════════════════════════════ */\n\n/* Backdrop */\n.adp-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 14, 30, 0.55);\n  z-index: 200;\n  backdrop-filter: blur(2px);\n  animation: adp-fade-in 0.2s ease;\n}\n@keyframes adp-fade-in { from { opacity: 0; } to { opacity: 1; } }\n\n/* Slide-in panel */\n.adp-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(520px, 100vw);\n  background: #f0f4f8;\n  z-index: 201;\n  /* Grid is the most reliable layout for header-fixed / body-scrolls pattern:\n     first row = header (auto height), second row = body (fills remaining space exactly) */\n  display: grid;\n  grid-template-rows: auto 1fr;\n  overflow: hidden;\n  box-shadow: -12px 0 48px rgba(0,0,0,0.22);\n  animation: adp-slide-in 0.24s cubic-bezier(0.16, 1, 0.3, 1);\n}\n@keyframes adp-slide-in {\n  from { transform: translateX(100%); }\n  to   { transform: translateX(0); }\n}\n\n/* ── Gradient header ──────────────────────────────────── */\n.adp-panel-header {\n  background: linear-gradient(135deg, #0d1b3e 0%, #1e4ba0 100%);\n  flex-shrink: 0;\n  padding: 20px 20px 0;\n}\n\n.adp-header-top {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n/* Initials avatar */\n.adp-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.18);\n  border: 2px solid rgba(255,255,255,0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 800;\n  color: #fff;\n  flex-shrink: 0;\n  letter-spacing: -1px;\n}\n\n.adp-header-info { flex: 1; min-width: 0; }\n.adp-panel-name {\n  font-size: 17px;\n  font-weight: 800;\n  color: #fff;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.adp-panel-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 3px;\n  flex-wrap: wrap;\n}\n.adp-panel-empid {\n  font-size: 11px;\n  color: rgba(255,255,255,0.55);\n  font-weight: 600;\n  font-family: monospace;\n}\n.adp-panel-date {\n  font-size: 11px;\n  color: rgba(255,255,255,0.65);\n}\n\n/* Close button — white circle */\n.adp-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255,255,255,0.15);\n  color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n.adp-close-btn:hover { background: rgba(255,255,255,0.28); }\n\n/* Status + verification chip strip */\n.adp-header-chips {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 0 16px;\n  flex-wrap: wrap;\n}\n.adp-vmode-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 11px;\n  background: rgba(255,255,255,0.15);\n  color: rgba(255,255,255,0.85);\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  border: 1px solid rgba(255,255,255,0.25);\n}\n\n/* Panel scrollable body\n   IMPORTANT: must be display:block (not flex).\n   flex+overflow-y causes \"scrollbar moves but content stays\" in Chrome. */\n.adp-panel-body {\n  /* Grid places this in the 1fr row — it fills the remaining panel height exactly */\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  padding: 18px 16px 24px;\n}\n\n/* Space between sections via sibling selector (replaces flex gap) */\n.adp-panel-body > * + * {\n  margin-top: 12px;\n}\n\n/* Loading */\n.adp-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 60px 24px;\n  color: #6b7280;\n  font-size: 13px;\n}\n.adp-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #1e5fbc;\n  border-radius: 50%;\n  animation: adp-spin 0.75s linear infinite;\n}\n@keyframes adp-spin { to { transform: rotate(360deg); } }\n\n/* Error */\n.adp-detail-error {\n  padding: 12px 16px;\n  border-radius: 10px;\n  background: #fff1f2;\n  border: 1px solid #fecdd3;\n  color: #be123c;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* ── Stats cards grid ─────────────────────────────────── */\n.adp-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n  gap: 8px;\n}\n\n.adp-stat-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 14px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  border-top: 3px solid #e2e8f0;\n}\n.adp-stat-card--in   { border-top-color: #16a34a; }\n.adp-stat-card--out  { border-top-color: #2563eb; }\n.adp-stat-card--work { border-top-color: #7c3aed; }\n.adp-stat-card--dist { border-top-color: #0891b2; }\n\n.adp-stat-card-ico {\n  font-size: 16px;\n  line-height: 1;\n}\n.adp-stat-card-val {\n  font-size: 18px;\n  font-weight: 800;\n  color: #1a2236;\n  line-height: 1;\n}\n.adp-stat-card--in  .adp-stat-card-val { color: #16a34a; }\n.adp-stat-card--out .adp-stat-card-val { color: #2563eb; }\n.adp-stat-card-lbl {\n  font-size: 10px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  text-align: center;\n}\n\n/* ── Alert banner (late / early) ──────────────────────── */\n.adp-alert-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 16px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.adp-alert-banner--late  { background: #fff7ed; color: #c2410c; border: 1.5px solid #fed7aa; }\n.adp-alert-banner--early { background: #eff6ff; color: #1d4ed8; border: 1.5px solid #bfdbfe; }\n.adp-alert-icon { font-size: 16px; flex-shrink: 0; }\n\n/* ── Face recognition card ────────────────────────────── */\n.adp-face-card {\n  background: linear-gradient(135deg, #f0f7ff, #e8f0fe);\n  border: 1.5px solid #bfdbfe;\n  border-radius: 14px;\n  padding: 14px 16px;\n}\n.adp-face-card-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #1e5fbc;\n  margin-bottom: 12px;\n}\n.adp-face-row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.adp-match-ring {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  flex-shrink: 0;\n}\n.adp-match-pct {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 800;\n}\n.adp-face-meta { flex: 1; }\n.adp-face-pct {\n  font-size: 26px;\n  font-weight: 800;\n  color: var(--ring-color, #1a2236);\n  line-height: 1.1;\n}\n.adp-face-hint {\n  font-size: 12px;\n  color: #374151;\n  margin-top: 5px;\n  font-weight: 500;\n}\n\n/* ── Sections ─────────────────────────────────────────── */\n.adp-section {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  overflow: hidden;\n  border: 1px solid #eaecf0;\n}\n.adp-section-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  color: #94a3b8;\n  padding: 11px 16px 9px;\n  border-bottom: 1px solid #f3f4f6;\n  margin: 0;\n  background: #fafbfc;\n}\n.adp-section-body { padding: 2px 0; }\n\n/* Info rows */\n.adp-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f8fafc;\n}\n.adp-row:last-child { border-bottom: none; }\n.adp-row-label {\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 500;\n  flex-shrink: 0;\n  padding-top: 1px;\n}\n.adp-row-value {\n  font-size: 13px;\n  color: #1a2236;\n  font-weight: 600;\n  text-align: right;\n  word-break: break-word;\n}\n.adp-row-value--hl { color: #1e5fbc; }\n\n/* ── Remarks card ─────────────────────────────────────── */\n.adp-remarks-card {\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #eaecf0;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n.adp-remarks-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  color: #94a3b8;\n  padding: 11px 16px 9px;\n  border-bottom: 1px solid #f3f4f6;\n  background: #fafbfc;\n}\n.adp-remarks {\n  font-size: 12px;\n  color: #374151;\n  line-height: 1.7;\n  padding: 12px 16px;\n  margin: 0;\n  white-space: pre-line;\n  word-break: break-word;\n}\n\n/* ── Activity timeline ────────────────────────────────── */\n.adp-timeline {\n  padding: 12px 14px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.adp-timeline-event {\n  display: flex;\n  gap: 14px;\n  position: relative;\n  padding-bottom: 18px;\n}\n.adp-timeline-event--last { padding-bottom: 4px; }\n\n/* vertical connector */\n.adp-timeline-event::before {\n  content: \"\";\n  position: absolute;\n  left: 9px;\n  top: 20px;\n  bottom: 0;\n  width: 2px;\n  background: linear-gradient(to bottom, #cbd5e1, transparent);\n}\n.adp-timeline-event--last::before { display: none; }\n\n/* dot */\n.adp-tl-dot {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  font-size: 10px;\n  font-weight: 900;\n  color: #fff;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.18);\n}\n.adp-tl-dot--in  { background: linear-gradient(135deg, #16a34a, #4ade80); }\n.adp-tl-dot--out { background: linear-gradient(135deg, #1d4ed8, #60a5fa); }\n\n/* event card */\n.adp-tl-body {\n  flex: 1;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #eaecf0;\n  padding: 10px 14px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.05);\n}\n\n.adp-tl-type {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a2236;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.adp-tl-mode {\n  font-size: 9px;\n  font-weight: 700;\n  background: #eff6ff;\n  color: #1e5fbc;\n  padding: 2px 7px;\n  border-radius: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  border: 1px solid #bfdbfe;\n}\n.adp-tl-time     { font-size: 12px; color: #374151; margin-top: 4px; font-weight: 600; }\n.adp-tl-location { font-size: 12px; color: #64748b; margin-top: 3px; font-weight: 500; }\n.adp-tl-address  { font-size: 11px; color: #94a3b8; margin-top: 2px; line-height: 1.4; }\n.adp-tl-latlng   { font-size: 10px; color: #cbd5e1; margin-top: 3px; font-family: monospace; }\n.adp-tl-match    { font-size: 11px; color: #6b7280; margin-top: 4px; }\n.adp-tl-match strong { color: #1a2236; }\n.adp-tl-worked   { font-size: 11px; color: #16a34a; margin-top: 3px; font-weight: 700; }\n.adp-tl-device   { font-size: 11px; color: #94a3b8; margin-top: 2px; }\n\n/* ══════════════════════════════════════════════════════════\n   Dark mode\n   ══════════════════════════════════════════════════════════ */\n.dark .ahp-root { background: #121827; }\n.dark .ahp-header { background: #1a2236; border-color: #2e3d52; }\n.dark .ahp-header-text h1 { color: #e2e8f0; }\n.dark .ahp-header-text p { color: #94a3b8; }\n.dark .ahp-back-btn { background: #263348; color: #cbd5e1; }\n.dark .ahp-back-btn:hover { background: #2e3d52; }\n.dark .ahp-toolbar { background: #1a2236; box-shadow: 0 2px 12px rgba(0,0,0,0.25); }\n.dark .ahp-field { color: #94a3b8; }\n.dark .ahp-input { background: #0f1724; border-color: #2e3d52; color: #e2e8f0; }\n.dark .ahp-input:focus { border-color: #7eb3ff; }\n.dark .ahp-error { background: #1f0a10; border-color: #9f1239; color: #fb7185; display: flex; align-items: center; }\n.dark .ahp-retry-btn { background: #1f0a10; border-color: #9f1239; color: #fb7185; }\n.dark .ahp-retry-btn:hover { background: #2d0d18; }\n.dark .ahp-result-count { color: #94a3b8; }\n.dark .ahp-emp-name { color: #e2e8f0; }\n.dark .ahp-emp-id { color: #4b5e76; }\n.dark .ahp-skeleton { background: #1a2236; }\n.dark .ahp-skeleton-cell {\n  background: linear-gradient(90deg, #1e2a3e 25%, #263348 50%, #1e2a3e 75%);\n  background-size: 200% 100%;\n}\n.dark .ahp-empty { color: #4b5e76; }\n.dark .ahp-table-wrap { background: #1a2236; box-shadow: 0 2px 12px rgba(0,0,0,0.25); }\n.dark .ahp-table thead { background: #0f1724; border-color: #2e3d52; }\n.dark .ahp-table th { color: #94a3b8; }\n.dark .ahp-table td { color: #e2e8f0; border-color: #1e2a3e; }\n.dark .ahp-table tbody tr:hover { background: #0f1724; }\n.dark .ahp-badge--in       { background: #052e16; color: #4ade80; }\n.dark .ahp-badge--out      { background: #1e3a5f; color: #93c5fd; }\n.dark .ahp-badge--overtime { background: #2d1f04; color: #fbbf24; }\n.dark .ahp-badge--halfday  { background: #2e1065; color: #c4b5fd; }\n.dark .ahp-badge--absent   { background: #450a0a; color: #fca5a5; }\n.dark .ahp-badge--off      { background: #1e2a3e; color: #64748b; }\n.dark .ahp-badge--leave    { background: #0c2a3e; color: #7dd3fc; }\n.dark .ahp-badge--late     { background: #3b1505; color: #fb923c; }\n.dark .ahp-badge--unknown  { background: #1e2a3e; color: #64748b; }\n.dark .ahp-page-btn { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }\n.dark .ahp-page-btn:hover:not(:disabled) { background: #263348; }\n.dark .ahp-page-info { color: #94a3b8; }\n\n/* ── Dark: clickable rows ────────────────────────────── */\n.dark .ahp-row-clickable:hover  { background: #0f1724; }\n.dark .ahp-row-chevron          { color: #2e3d52; }\n.dark .ahp-row-clickable:hover .ahp-row-chevron { color: #7eb3ff; }\n\n/* ── Dark: detail panel ──────────────────────────────── */\n.dark .adp-backdrop  { background: rgba(0,0,0,0.72); }\n.dark .adp-panel     { background: #0f1724; }\n\n/* header gradient stays in dark mode — already dark enough */\n.dark .adp-panel-header { background: linear-gradient(135deg, #060d1e 0%, #0f2d6a 100%); }\n.dark .adp-close-btn    { background: rgba(255,255,255,0.12); color: #e2e8f0; }\n.dark .adp-close-btn:hover { background: rgba(255,255,255,0.22); }\n\n/* stats */\n.dark .adp-stats-grid .adp-stat-card { background: #1a2236; border-color: #2e3d52; box-shadow: 0 2px 8px rgba(0,0,0,0.3); }\n.dark .adp-stat-card-val              { color: #e2e8f0; }\n.dark .adp-stat-card--in  .adp-stat-card-val { color: #4ade80; }\n.dark .adp-stat-card--out .adp-stat-card-val { color: #93c5fd; }\n.dark .adp-stat-card-lbl              { color: #4b5e76; }\n\n/* alert banners */\n.dark .adp-alert-banner--late  { background: #1c0a00; color: #fb923c; border-color: #7c2d12; }\n.dark .adp-alert-banner--early { background: #0c1a3e; color: #93c5fd; border-color: #1e3a6e; }\n\n/* face card */\n.dark .adp-face-card       { background: linear-gradient(135deg, #0f1f3d, #1e2a52); border-color: #1e3a6e; }\n.dark .adp-face-card-title { color: #7eb3ff; }\n.dark .adp-face-pct        { /* uses CSS var --ring-color */ }\n.dark .adp-face-hint       { color: #94a3b8; }\n\n/* sections */\n.dark .adp-section       { background: #1a2236; border-color: #2e3d52; box-shadow: 0 2px 8px rgba(0,0,0,0.3); }\n.dark .adp-section-title { color: #4b5e76; border-color: #2e3d52; background: #131e30; }\n.dark .adp-section-body  { }\n.dark .adp-row           { border-color: #1e2a3e; }\n.dark .adp-row-label     { color: #4b5e76; }\n.dark .adp-row-value     { color: #e2e8f0; }\n.dark .adp-row-value--hl { color: #7eb3ff; }\n\n/* remarks */\n.dark .adp-remarks-card  { background: #1a2236; border-color: #2e3d52; }\n.dark .adp-remarks-title { color: #4b5e76; border-color: #2e3d52; background: #131e30; }\n.dark .adp-remarks       { color: #94a3b8; }\n\n/* timeline */\n.dark .adp-timeline-event::before { background: linear-gradient(to bottom, #2e3d52, transparent); }\n.dark .adp-tl-dot--in  { background: linear-gradient(135deg, #16a34a, #4ade80); }\n.dark .adp-tl-dot--out { background: linear-gradient(135deg, #1d4ed8, #60a5fa); }\n.dark .adp-tl-body     { background: #1a2236; border-color: #2e3d52; }\n.dark .adp-tl-type     { color: #e2e8f0; }\n.dark .adp-tl-mode     { background: #0f1f3d; color: #7eb3ff; border-color: #1e3a6e; }\n.dark .adp-tl-time     { color: #cbd5e1; }\n.dark .adp-tl-location { color: #94a3b8; }\n.dark .adp-tl-address  { color: #64748b; }\n.dark .adp-tl-latlng   { color: #374151; }\n.dark .adp-tl-match    { color: #64748b; }\n.dark .adp-tl-match strong { color: #cbd5e1; }\n.dark .adp-tl-worked   { color: #4ade80; }\n.dark .adp-tl-device   { color: #4b5e76; }\n\n/* loading / error */\n.dark .adp-loading      { color: #4b5e76; }\n.dark .adp-spinner      { border-color: #2e3d52; border-top-color: #7eb3ff; }\n.dark .adp-detail-error { background: #1f0a10; border-color: #9f1239; color: #fb7185; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
